import React, { useState, useCallback, useMemo } from "react";
import AlertNotification from "../components/AlertNotification";
import { Auth } from "aws-amplify";
import { TextField, IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Formik, Form } from "formik";
import * as yup from "yup";
import { passwordValidation } from "../components/PasswordComponent";
import s from "./Setting.module.scss";

const ChangePassword = ({ userData }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const handleAlertOpen = useCallback(() => setAlertOpen(true), []);

  const handlePasswordChange = useCallback(
    async (model, { setErrors, resetForm, setStatus }) => {
      try {
        await Auth.changePassword(userData, model.old_password, model.new_password);
        const status = { message: "successfully changed password" };
        handleAlertOpen();
        setStatus(status);
        resetForm({ status });
      } catch (error) {
        setErrors({ api: error?.message });
        setStatus({});
      }
    },
    [handleAlertOpen, userData]
  );

  return (
    <>
      <div className={s.sectionTitle}>Change Password</div>
      <Formik
        initialValues={{ old_password: "", new_password: "" }}
        validationSchema={yup.object().shape({
          old_password: yup.string("Enter your current password").required("Current password is required"),
          new_password: passwordValidation().notOneOf(
            [yup.ref("old_password")],
            "New password same as current password."
          ),
        })}
        onSubmit={(values, formikBag) => {
          handlePasswordChange(values, formikBag);
        }}>
        {({ values, errors, touched, status, handleChange }) => (
          <Form>
            {errors?.api && <div className={s.errorMsg}>{errors.api}</div>}
            {status?.message && <div className={s.successMsg}>{status.message}</div>}
            <div className={s.fieldGroup}>
              <TextField
                fullWidth
                variant="outlined"
                size="small"
                id="oldpassword"
                name="old_password"
                placeholder="Current Password"
                autoComplete="current-password"
                type={showPassword ? "text" : "password"}
                value={values.old_password}
                onChange={handleChange}
                error={touched.old_password && Boolean(errors.old_password)}
                helperText={touched.old_password && errors.old_password}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)}
                        onMouseDown={(e) => e.preventDefault()}>
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                fullWidth
                variant="outlined"
                size="small"
                id="newpassword"
                name="new_password"
                placeholder="New Password"
                autoComplete="new-password"
                type={showNewPassword ? "text" : "password"}
                value={values.new_password}
                onChange={handleChange}
                error={touched.new_password && Boolean(errors.new_password)}
                helperText={touched.new_password && errors.new_password}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowNewPassword(!showNewPassword)}
                        onMouseDown={(e) => e.preventDefault()}>
                        {showNewPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <button type="submit" className={s.submitBtn} id="change_password_submit_button">
              Update Password
            </button>
          </Form>
        )}
      </Formik>
      <AlertNotification message="New user settings have been saved." severity={null} open={alertOpen} setOpen={setAlertOpen} />
    </>
  );
};

export default ChangePassword;
